import { Check, AlertTriangle, X } from "lucide-react";

const COLORS = {
  safe: { bg: "#00B259", fg: "#FFFFFF", label: "GENUINE" },
  suspicious: { bg: "#FFC400", fg: "#050505", label: "CAUTION" },
  dangerous: { bg: "#E53935", fg: "#FFFFFF", label: "DANGER" },
};

export default function VerdictMark({ verdict = "safe", risk = 0, size = 160 }) {
  const c = COLORS[verdict] || COLORS.safe;
  const Icon = verdict === "safe" ? Check : verdict === "suspicious" ? AlertTriangle : X;
  const isSquare = verdict === "safe";
  const isTri = verdict === "suspicious";

  return (
    <div className="flex flex-col items-center gap-3" data-testid={`verdict-mark-${verdict}`}>
      <div
        style={{
          width: size,
          height: size,
          background: c.bg,
          color: c.fg,
          border: "3px solid #050505",
          boxShadow: "6px 6px 0 0 #050505",
          clipPath: isTri
            ? "polygon(50% 0, 100% 100%, 0 100%)"
            : isSquare
            ? "none"
            : "polygon(30% 0, 70% 0, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0 70%, 0 30%)",
        }}
        className="flex items-center justify-center"
      >
        <Icon size={size * 0.45} strokeWidth={3} />
      </div>
      <div className="flex items-center gap-3">
        <span className="text-xs font-bold tracking-[0.3em] uppercase">{c.label}</span>
        <span className="text-xs font-bold tracking-wider px-2 py-1 border-2 border-black bg-white" data-testid="risk-pill">
          RISK {risk}/100
        </span>
      </div>
    </div>
  );
}
